import React, { useEffect, useState } from "react";
import { Table, Spinner, Button } from "reactstrap";
import { toast } from "react-toastify";
import { getDepartmentsApi, getInactiveDepartmentsApi, deleteDepartmentApi, reactivateDepartmentApi } from "../../../apiServices/department.services";

const DepartmentList = ({ search, refresh, tab, setMode, setSelectedDepartment, setModal }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      setLoading(true);

      let res;

      if (tab === "active") {
        res = await getDepartmentsApi({ search });
        setData(res?.data?.data || []);
      } else {
        res = await getInactiveDepartmentsApi({ search });
          const raw = res?.data?.data || [];
          let flat = [];
          raw.forEach(parent => {
            if (parent.status === "inactive") {
              flat.push(parent);
            }
            if (parent.children?.length) {
              const inactiveChildren = parent.children.filter(
                child => child.status === "inactive"
              );
              flat.push(...inactiveChildren.map(child => ({
                ...child,
                parentDepartmentId: {
                  name: parent.name 
                }
              })));
            }
          });
          setData(flat);
      }
    } catch (err) {
      toast.error("Failed to fetch departments");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [search, refresh, tab]);

  const handleDelete = async (id) => {
    try {
      await deleteDepartmentApi(id);
      toast.success("Department deleted");
      fetchData();
    } catch {
      toast.error("Delete failed");
    }
  };

  const handleReactivate = async (id) => {
    try {
      await reactivateDepartmentApi(id);
      toast.success("Department reactivated");
      fetchData();
    } catch {
      toast.error("Reactivate failed");
    }
  };

  if (loading) return <Spinner />;

  return (
    <div className="table-responsive">
      <Table className="table-bordered align-middle">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Code</th>
            <th>Under</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {data.map((d, i) => (
            <tr key={d._id}>
              <td>{i + 1}</td>
              <td>{d.name}</td>
              <td>{d.code}</td>
              <td>{d?.parentDepartmentId?.name || "-"}</td>
              <td>{d.status}</td>

              <td>
                {tab === "active" && (
                  <Button
                    size="sm"
                    color="primary"
                    className="me-2"
                    onClick={() => { setMode("edit"); setSelectedDepartment(d); setModal(true); }}
                  >
                    Edit
                  </Button>
                )}

                {tab === "active" ? (
                  <Button size="sm" color="danger" onClick={() => handleDelete(d._id)} > Delete </Button>
                ) : (
                  <Button className="hidden" size="sm" color="success" onClick={() => handleReactivate(d._id)} > Reactivate </Button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default DepartmentList;